<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <Input
            class="height45"
            v-model="templateName"
            placeholder="请输入搜索的模板名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <div style="margin-right: 10px">审核状态：</div>
          <Select
            class="height45"
            v-model="templateStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in templateStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">模板列表（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="name" slot-scope="{ row }">
          <div class="tname">
            <img :src="row.type === 0 ? tp : te" />
            <span>{{ row.name }} </span>
            <span style="color:#2d8cf0">({{row.count}})</span>
          </div>
        </template>
        <template slot="locName" slot-scope="{ row }">
          <div>
            {{
              row.type === 0 ? row.locName : row.locBusinessName
            }}
          </div>
        </template>
        <template slot="status" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            @click="showDetail(row)"
            >查看模板</Button
          >
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            v-if="row.count > 0"
            @click="showList(row)"
            >域名列表</Button
          >
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            v-if="row.status === 3"
            @click="showReason(row)"
            >原因</Button
          >
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            v-if="row.isTemporary == 0"
            @click="copy(row.id)"
            >复制</Button
          >
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            v-if="row.count <= 0 && row.isTemporary !== 1"
            @click="del(row)"
            >删除</Button
          >
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <!-- 模板详情模态框 -->
    <templateInfoModal
      :show.sync="templateInfoModalVisibility"
      :data="templateInfoModalDetail"
    ></templateInfoModal>
    <!-- 域名列表模态框 -->
    <templateInfoListModal
      :show.sync="templateInfoModalListVisibility"
      :templateId="templateInfoModalId"
    ></templateInfoListModal>
  </div>
</template>
<script>
import { templatesList, deleteTemplate,getTemplateCopy } from "api/domain.js";
import templateInfoModal from "components/template/templateInfoModal.vue";
import templateInfoListModal from "components/template/templateInfoListModal.vue";
import { mapMutations } from "vuex";

export default {
  name: "template1",
  components: {
    templateInfoModal,
    templateInfoListModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未审核";
          break;
        case 1:
          title = "审核中";
          break;
        case 2:
          title = "审核通过";
          break;
        case 3:
          title = "审核未通过";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      te: require("@/assets/image/t-enterprise.png"),
      tp: require("@/assets/image/t-personal.png"),
      templateInfoModalVisibility: false,
      templateInfoModalDetail: null,
      templateInfoModalListVisibility: false,
      templateInfoModalId: "",
      templateInfoName: "",
      templateStatus: "",
      templateStatusList: [
        {
          value: 0,
          label: "未审核",
        },
        {
          value: 1,
          label: "审核中",
        },
        {
          value: 2,
          label: "审核通过",
        },
        {
          value: 3,
          label: "审核未通过",
        },
      ],
      templateName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "模板名称",
          align: "center",
          slot: "name",
        },
        {
          title: "联系人",
          align: "center",
          slot: "locName",
        },
        {
          title: "更新日期",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          width: 350,
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    ...mapMutations(["MUT_DOMAIN_TEMPLATECOPY"]),
    // 请求
    async req_getList() {
      try {
        const params = {
          templateName: this.templateName,
          templateStatus: this.templateStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await templatesList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.templateName = "";
      this.templateStatus = "";
      this.onPageChange(1);
    },
    // 查看详情
    showDetail(val) {
      this.templateInfoModalVisibility = true;
      this.templateInfoModalDetail = val;
    },
    // 查看域名列表
    showList(val) {
      this.templateInfoModalListVisibility = true;
      this.templateInfoModalId = val.id;
    },
    // 删除
    del(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: `<p>确定要删除此模板吗？</p>`,
        onOk: async () => {
          try {
            const { code, result } = await deleteTemplate(val.id);
            if (code === 200 && result) {
              this.$Message.success("操作成功！");
              this.req_getList();
            }
          } catch (error) {
            this.$Message.warning("操作失败！");
            console.log(error);
          }
        },
      });
    },
    // 查看原因
    showReason(val) {
      this.$Modal.confirm({
        title: "审核失败原因",
        content: val.description,
      });
    },
     // 复制模板
    async copy(id) {
      this.loading = true;
      let res = await getTemplateCopy({
        templateId: id,
      });
      if (res.code == 200) {
        this.MUT_DOMAIN_TEMPLATECOPY(res.data)
        this.$router.push({
          name: "templateAdd",

        });
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
 margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
